<template>
  <ReactSiteFrame :src="src" />
</template>
<script>
import ReactSiteFrame from '../components/react/iframe'

export default {
  name: 'AccountsReact',
  components: {
    ReactSiteFrame
  },
  data() {
    return {
      src: '/view/accounts'
    }
  }
}
</script>
